import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit"
import rootReducer from "./rootreducer"

// setup 関数を用意してエクスポートする。
const setupStore = () => {
  const middlewares = [...getDefaultMiddleware()]

  const store = configureStore({
    reducer: rootReducer,
    middleware: middlewares,
  })

  return store
}
export default setupStore
